import React from 'react';
import { useResponsive, getResponsiveTextClasses, getResponsiveSpacingClasses, getTouchAccessibilityClasses } from '@/lib/responsive-utils';
import type { ClientLogo } from '@/types';

interface ClientLogosProps {
  logos: ClientLogo[];
  speed?: number;
  className?: string;
}

export const ClientLogos: React.FC<ClientLogosProps> = ({
  logos,
  speed = 80,
  className = '',
}) => {
  const { isMobile, isTablet } = useResponsive();
  
  // Duplicate logos multiple times for seamless looping on all screen sizes
  const duplicatedLogos = [...logos, ...logos, ...logos];

  return (
    <section className={`${getResponsiveSpacingClasses('py', 4, 6, 8)} ${getTouchAccessibilityClasses()} ${className} overflow-hidden`}>
      <div className="w-full overflow-hidden">
        
        {/* Section Header - Fixed, no animation */}
        <div className={`text-center ${getResponsiveSpacingClasses('mb', 4, 6, 8)}`}>
          {/* Badge */}
         
          <div className="inline-flex items-center gap-2 text-liec-primary-500 font-semibold text-sm uppercase tracking-wider mb-6">
            COLABORADORES
          </div>


           <svg className='inline-flex items-center gap-2 ml-2' width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line x1="0.330774" y1="5.41623" x2="11.9289" y2="11.1156" stroke="#E34C0E" stroke-width="1.5"/>
            <path d="M6.36253 13.292L12.4163 11.2088L10.5026 4.91892" stroke="#E34C0E" stroke-width="1.5"/>
            </svg>


          <h2 className={getResponsiveTextClasses(
            'text-2xl font-bold text-gray-900 mb-12',
            'text-3xl',
            'text-4xl'
          )}>
            Aliados Estratégicos
          </h2>
        </div>

        {/* Logos Carousel Container - with overflow hidden */}
        <div className="relative overflow-hidden w-full">
          {/* Scrolling container - animation applied here */}
          <div 
            className="flex items-center client-logos-scroll will-change-transform gap-8"
            style={{
              width: 'max-content',
            } as React.CSSProperties}
          >
            {duplicatedLogos.map((logo, index) => (
              <div
                key={`${logo.id}-${index}`}
                className={`flex-shrink-0 flex items-center justify-center hover:shadow-md transition-shadow duration-300 ${getResponsiveSpacingClasses('p', 2, 3, 4)} ${
                  isMobile 
                    ? 'w-24 h-12' 
                    : isTablet 
                    ? 'w-28 h-14' 
                    : 'w-40 h-20'
                }`}
              >
                <img
                  src={logo.logo}
                  alt={logo.alt}
                  className="max-w-full max-h-full object-contain filter hover:grayscale-0 transition-all duration-300"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientLogos;
